import { useMutation, useQueryClient } from '@tanstack/react-query';

import { client } from '../http/api';
import { TrustedOrigins } from '../types/trustedOrigins';

async function createTrustedOrigin(data) {
  const response = await client.post<TrustedOrigins>(`/auth/origin`, data, {
    withCredentials: true,
  });
  return response.data;
}

function useCreateTrustedOrigin() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: createTrustedOrigin,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['TrustedOrigins'] });
    },
  });
}

export { useCreateTrustedOrigin };
export default useCreateTrustedOrigin;
